import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import QRCode from "react-qr-code";
import toast from "react-hot-toast";
import { Copy, ExternalLink } from "lucide-react";

import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  businessUrl: string;
};

/**
 * Shows the merchant's general business-page link as a shareable QR code
 * alongside copy/visit actions — mirrors PaymentSuccessDialog, but for the
 * business link rather than a single payment page.
 */
const BusinessLinkDialog = ({ open, onOpenChange, businessUrl }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="font-manrope mds:max-w-[440px]">
        <DialogHeader className="items-center text-center">
          <DialogTitle className="font-sora text-[18px]">
            Your business link
          </DialogTitle>
          <DialogDescription>
            Share the link or QR code so customers can see all your payment
            pages in one place.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center gap-3">
          <div className="rounded-xl border bg-white p-3">
            <QRCode value={businessUrl} size={140} />
          </div>
          <p className="break-all text-center text-[12px] font-medium text-muted-foreground">
            {businessUrl}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2 pt-2">
          <CopyToClipboard
            text={businessUrl}
            onCopy={() => toast.success("Business link copied")}
          >
            <Button
              variant="outline"
              className="h-11 gap-2 rounded-xl bg-background"
            >
              <Copy className="size-4" />
              Copy link
            </Button>
          </CopyToClipboard>
          <Button
            onClick={() => window.open(businessUrl, "_blank")}
            className="h-11 gap-2 rounded-xl"
          >
            <ExternalLink className="size-4" />
            Visit page
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BusinessLinkDialog;
